import { cn } from "@/lib/utils";

interface VeeraThreadContextHeaderProps {
  sourceLabel: string;
  className?: string;
}

export function VeeraThreadContextHeader({
  sourceLabel,
  className,
}: VeeraThreadContextHeaderProps) {
  if (!sourceLabel.trim()) return null;

  return (
    <div
      className={cn(
        "inline-flex rounded-full border border-border/70 bg-muted/40 px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.16em] text-muted-foreground",
        className,
      )}
    >
      {sourceLabel}
    </div>
  );
}
